// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10NoM","questions":"styles_questions__2jPv8","footer":"styles_footer__NO0mZ"};